<template>
  <div
    class="circular-menu relative text-chplus-menu"
    @touchstart="onTouchstart"
    @touchmove="onTouchmove"
    @touchend="onTouchend"
  >
    <div ref="container" class="absolute-center h-full">
      <circular-slice-top
        :highlightOpacity="highlightOpacity"
        :locked="lockedTop"
        :interaction-bus="interactionBus"
        :show-notification="notificationTop"
      />
      <circular-slice-right
        :highlightOpacity="highlightOpacity"
        :locked="lockedRight"
        :interaction-bus="interactionBus"
        :show-notification="notificationRight"
      />
      <circular-slice-bottom
        :highlightOpacity="highlightOpacity"
        :locked="lockedBottom"
        :interaction-bus="interactionBus"
        :show-notification="notificationBottom"
      />
      <circular-slice-left
        :highlightOpacity="highlightOpacity"
        :locked="lockedLeft"
        :interaction-bus="interactionBus"
        :show-notification="notificationLeft"
      />
      <img
        src="data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs="
        class="absolute top-0 left-0 w-full h-full opacity-0 rounded-full"
        style="pointer-events: fill"
        usemap="#circular-menu"
        alt=""
      />
      <circular-slice-center
        :questions-answerd="hasAnsweredQuestions"
        :show-notification="!hasAnsweredQuestions"
      />
      <div
        class="absolute top-0 right-0 bottom-0 left-0 z-0 pointer-events-none"
        style="padding: 32%"
        v-if="hasAnsweredQuestions"
      >
        <smart-spider />
      </div>
      <map
        class="absolute top-0 left-0 w-full h-full pointer-events-none"
        name="circular-menu"
        ><area
          shape="poly"
          :coords="sliceTop"
          alt=""
          :class="{ 'cursor-pointer': !lockedLeft }"
          @click="
            $event.preventDefault();
            $router
              .push({
                name: lockedTop ? null : 'dream-teams'
              })
              .catch(() => {});
          "
          @mouseenter="onPointerEnter('top')"
          @mouseleave="onPointerExit('top')"
          @mousedown="onPointerDown('top')"
          @mouseup="onPointerUp('top')"
          @touchdown="onPointerDown('top')"
          @touchend="onPointerUp('top')"
        /><area
          shape="poly"
          :coords="sliceRight"
          alt=""
          :class="{ 'cursor-pointer': !lockedLeft }"
          @click="
            $event.preventDefault();
            $router.push({
              name: lockedRight ? null : 'match'
            });
          "
          @mouseenter="onPointerEnter('right')"
          @mouseleave="onPointerExit('right')"
          @mousedown="onPointerDown('right')"
          @mouseup="onPointerUp('right')"
          @touchdown="onPointerDown('right')"
          @touchend="onPointerUp('right')"
        /><area
          shape="poly"
          :coords="sliceBottom"
          alt=""
          :class="{ 'cursor-pointer': !lockedLeft }"
          @click="
            $event.preventDefault();
            $router.push({
              name: lockedBottom ? null : 'favorites'
            });
          "
          @mouseenter="onPointerEnter('bottom')"
          @mouseleave="onPointerExit('bottom')"
          @mousedown="onPointerDown('bottom')"
          @mouseup="onPointerUp('bottom')"
          @touchdown="onPointerDown('bottom')"
          @touchend="onPointerUp('bottom')"
        /><area
          shape="poly"
          :coords="sliceLeft"
          alt=""
          :class="{ 'cursor-pointer': !lockedLeft }"
          @click="
            $event.preventDefault();
            $router.push({
              name: lockedLeft ? null : 'lists'
            });
          "
          @mouseenter="onPointerEnter('left')"
          @mouseleave="onPointerExit('left')"
          @mousedown="onPointerDown('left')"
          @mouseup="onPointerUp('left')"
          @touchdown="onPointerDown('left')"
          @touchend="onPointerUp('left')"
        />
      </map>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import SmartSpider from "@/components/chart/SmartSpider";
import { ProgressStepId } from "@/utils/ProgressStepId";
import { ElectionProgressStepId } from "@/utils/ElectionProgressStepId";
import CircularSliceTop from "@/components/nav/circular/CircularSliceTop";
import CircularSliceRight from "@/components/nav/circular/CircularSliceRight";
import CircularSliceBottom from "@/components/nav/circular/CircularSliceBottom";
import CircularSliceLeft from "@/components/nav/circular/CircularSliceLeft";
import CircularSliceCenter from "@/components/nav/circular/CircularSliceCenter";
import Vue from "vue";

export default {
  name: "CircularMenu",
  components: {
    CircularSliceCenter,
    CircularSliceLeft,
    CircularSliceBottom,
    CircularSliceRight,
    CircularSliceTop,
    SmartSpider
  },
  props: {
    levelSwitchBus: {
      type: Vue,
      required: true
    },
    highlightOpacity: {
      type: Number,
      default: 0
    }
  },
  data: () => ({
    sliceTop: "",
    sliceRight: "",
    sliceBottom: "",
    sliceLeft: "",
    interactionBus: new Vue()
  }),
  mounted() {
    this.hookEvents();
    this.recalculateSize();
    setTimeout(() => this.recalculateSize(), 1);
  },
  beforeDestroy() {
    this.releaseHooks();
  },
  computed: {
    ...mapGetters("user", ["hasProgress"]),
    ...mapGetters("election", ["activeElection", "hasElectionProgress"]),
    ...mapGetters("list", ["lists"]),
    ...mapGetters("questionnaire", ["shortAnswered", "smartSpider"]),
    activeElectionId() {
      return this.activeElection.id;
    },
    hasOfficialLists() {
      return this.lists.filter(l => l.adapted === null).length > 0;
    },
    hasAnsweredQuestions() {
      return (
        this.hasProgress(ProgressStepId.Questionnaire) && this.shortAnswered
      );
    },
    hasMatchedCandidates() {
      let hasMatchedCandidates = this.hasProgress(ProgressStepId.Match);
      let hasMatchedElectionCandidates = this.hasElectionProgress(
        ElectionProgressStepId.Match,
        this.activeElection.id
      );
      return hasMatchedCandidates && hasMatchedElectionCandidates;
    },
    hasSeenFavorites() {
      return this.hasProgress(ProgressStepId.Favorites);
    },
    hasCreatedList() {
      return this.hasProgress(ProgressStepId.CustomList);
    },
    hasFavoriteList() {
      return this.hasProgress(ProgressStepId.FavoriteList);
    },
    hasSeenDreamTeams() {
      return this.hasProgress(ProgressStepId.DreamTeams);
    },
    hasSeenResults() {
      return this.hasProgress(ProgressStepId.Results);
    },
    hasSeenListsTutorial() {
      return this.hasProgress(ProgressStepId.TutorialLists);
    },
    lockedTop() {
      let hasFavoriteList = this.hasProgress(ProgressStepId.FavoriteList);
      let hasMatchedElectionCandidates = this.hasElectionProgress(
        ElectionProgressStepId.Match,
        this.activeElection.id
      );
      return !hasFavoriteList || !hasMatchedElectionCandidates;
    },
    lockedRight() {
      return !this.shortAnswered;
    },
    lockedBottom() {
      let hasMatchedCandidates = this.hasProgress(ProgressStepId.Match);
      let hasMatchedElectionCandidates = this.hasElectionProgress(
        ElectionProgressStepId.Match,
        this.activeElection.id
      );
      return !hasMatchedCandidates || !hasMatchedElectionCandidates;
    },
    lockedLeft() {
      let hasSeenFavorites = this.hasProgress(ProgressStepId.Favorites);
      let hasMatchedElectionCandidates = this.hasElectionProgress(
        ElectionProgressStepId.Match,
        this.activeElection.id
      );
      return !hasSeenFavorites || !hasMatchedElectionCandidates;
    },
    notificationTop() {
      return !this.hasSeenResults;
    },
    notificationRight() {
      return !this.hasMatchedCandidates;
    },
    notificationBottom() {
      return !this.hasSeenFavorites;
    },
    notificationLeft() {
      return (
        !this.hasFavoriteList ||
        (this.hasOfficialLists && !this.hasProgress(ProgressStepId.SeenAll))
      );
    }
  },
  methods: {
    ...mapActions(["store", "get"]),
    ...mapActions("list", ["createList"]),
    ...mapActions("user", ["updateUser", "updateProgression"]),
    async navigateListEditor() {
      try {
        await this.$router.push({ name: "list-editor" });
      } catch (e) {
        // Ignore multi-redirect error
      }
    },
    onWindowResize() {
      this.recalculateSize();
    },
    recalculateSize() {
      // top: 0,0,50,50,100,0
      // right: 100,0,50,50,100,100
      // bottom: 0,100,50,50,100,100
      // left: 0,0,50,50,0,100
      const container = this.$refs["container"];
      const elementStyle = getComputedStyle(this.$el);
      const availableWidth = parseInt(elementStyle.width);
      this.$el.style.height = availableWidth + "px";
      this.$el.style.offsetTop;
      const containerStyle = getComputedStyle(container);
      const size = parseInt(containerStyle.height);
      const center = size * 0.5;
      container.style.width = size + "px";
      this.sliceTop = [0, 0, center, center, size, 0].join(",");
      this.sliceRight = [size, 0, center, center, size, size].join(",");
      this.sliceBottom = [0, size, center, center, size, size].join(",");
      this.sliceLeft = [0, 0, center, center, 0, size].join(",");
    },
    hookEvents() {
      document.addEventListener("mouseup", this.onPointerUp);
      document.addEventListener("touchend", this.onPointerUp);
      window.addEventListener("resize", this.onWindowResize);
    },
    releaseHooks() {
      document.removeEventListener("mouseup", this.onPointerUp);
      document.removeEventListener("touchend", this.onPointerUp);
      window.removeEventListener("resize", this.onWindowResize);
    },
    onPointerDown(slice) {
      this.interactionBus.$emit("pointerdown", slice);
    },
    onPointerUp(slice) {
      this.interactionBus.$emit("pointerup", slice);
    },
    onPointerEnter(slice) {
      this.interactionBus.$emit("pointerenter", slice);
    },
    onPointerExit(slice) {
      this.interactionBus.$emit("pointerexit", slice);
    },
    onTouchstart(e) {
      this.levelSwitchBus.$emit("touch-start", e);
    },
    onTouchmove(e) {
      this.levelSwitchBus.$emit("touch-move", e);
    },
    onTouchend() {
      this.levelSwitchBus.$emit("touch-end");
    }
  }
};
</script>

<style lang="scss" scoped>
.text-icon {
  font-size: 35px;
}

.text-dark {
  color: #5f6888;
}

tspan {
  font-weight: bold;
}

.menu-accent-outer-1,
.menu-accent-outer-2,
.menu-section-B,
.menu-section-A,
.menu-section-C,
.menu-section-inner,
.menu-accent-outer-14,
.cls-30 {
  fill: #fff;
}

.menu-accent-outer-1 {
  opacity: 0.1;
}

.menu-accent-outer-2 {
  opacity: 0.1;
}

.menu-section-A {
  opacity: 0.35;
}

.menu-section-B {
  opacity: 0.6;
}

.menu-section-C {
  opacity: 0.95;
}

.menu-section-inner {
  opacity: 0.08;
}

.locked {
  opacity: 0.5;
}

.cls-26,
.cls-29,
.cls-7 {
  fill: none;
  stroke-miterlimit: 10;
}

.cls-30,
.cls-7 {
  stroke: #fff;
}

.cls-7 {
  stroke-width: 0.5px;
}

.cls-26,
.cls-29 {
  stroke: #5f6888;
}

.cls-26 {
  stroke-width: 2px;
}

.cls-29 {
  stroke-width: 5px;
}

.cls-30 {
  stroke-linejoin: round;
  stroke-width: 3px;
}

.cls-33 {
  fill: none;
  stroke: #fff;
  stroke-width: 7px;
}

.circle-slice {
  transition: transform 0.1s ease-in-out;
  -webkit-transition: -webkit-transform 0.1s ease-in-out;
  transform-origin: 418px 418px;
  -webkit-transform-origin: 418px 418px;
}

$slice-scale-strength: 1.05;
$slice-animation-strength: 1.05em;

.circle-slice.active#menu-top {
  transform: scale($slice-scale-strength)
    translate(0, -$slice-animation-strength);
  -webkit-transform: scale($slice-scale-strength)
    translate(0, -$slice-animation-strength);
}

.circle-slice.active#menu-right {
  transform: scale($slice-scale-strength)
    translate($slice-animation-strength, 0);
  -webkit-transform: scale($slice-scale-strength)
    translate($slice-animation-strength, 0);
}

.circle-slice.active#menu-bottom {
  transform: scale($slice-scale-strength)
    translate(0, $slice-animation-strength);
  -webkit-transform: scale($slice-scale-strength)
    translate(0, $slice-animation-strength);
}

.circle-slice.active#menu-left {
  transform: scale($slice-scale-strength)
    translate(-$slice-animation-strength, 0);
  -webkit-transform: scale($slice-scale-strength)
    translate(-$slice-animation-strength, 0);
}

.circle-slice .menu-section-A {
  transition: opacity 0.1s;
}

#app.mouse .circle-slice:hover .menu-section-A {
  opacity: 0.5;
}

.circle-slice.active .menu-section-A {
  opacity: 0.8;
}

#app.mouse .circle-slice:hover .menu-section-B {
  opacity: 0.7;
}

.circle-slice.active .menu-section-B {
  opacity: 0.8;
}

#app.mouse .circle-slice:hover .menu-section-C {
  opacity: 1;
}

.circle-slice.active .menu-section-C {
  opacity: 1;
}

.circle-slice .menu-accent-outer-1 {
  transition: opacity 0.1s;
}

.circle-slice.active .menu-accent-outer-1 {
  opacity: 1;
}
</style>
